/* eslint-disable @typescript-eslint/no-explicit-any */
// ** React Imports
import { useContext } from 'react'

// ** Vertical Menu Components
import VerticalNavMenuLink from './VerticalNavMenuLink'
import VerticalNavMenuGroup from './VerticalNavMenuGroup'
import VerticalNavMenuSectionHeader from './VerticalNavMenuSectionHeader'

// ** Context
import { AbilityContext } from '@src/utility/context/Can'

// ** Utils
import {
  canViewMenuItemWithAbility,
  canViewMenuGroupWithAbility,
  resolveVerticalNavMenuItemComponent as resolveNavItemComponent
} from '@src/@core/layouts/utils'

const VerticalMenuNavItems = (props: any) => {
  // ✅ Hook called once at component level (fixes React Hooks order error)
  const ability = useContext(AbilityContext)
  
  // ** Components Object
  const Components = {
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
    VerticalNavMenuSectionHeader
  }

  // ** Render Nav Menu Items
  const RenderNavItems = props.items.map((item: any, index: any) => {
    const TagName = Components[resolveNavItemComponent(item)]
    
    if (item.children) {
      // ✅ Use pure function with ability parameter (no hook inside map)
      return canViewMenuGroupWithAbility(item, ability) && (
        <TagName item={item} index={index} key={item.id} {...props} />
      )
    }
    
    // ✅ Use pure function with ability parameter (no hook inside map)
    return canViewMenuItemWithAbility(item, ability) && (
      <TagName key={item.id || item.header} item={item} {...props} />
    )
  })

  return RenderNavItems
}

export default VerticalMenuNavItems